import SplashScreen from '@/Screens/SplashScreen';
import { useAuth } from '@/Services/AuthContext';
import React, { useState } from 'react';
function AuthGuard({ children }) {
	const { user, isAuthenticated, loading, login, logout } = useAuth();

	if (isAuthenticated) {
		return children;
	}
	else
		return <SplashScreen></SplashScreen>
}
export default AuthGuard;